export const getSearchParam = (search, paramName) => {
  if (search && paramName) {
    const params = new URLSearchParams(search);
    return params.get(paramName) ?? undefined;
  }
};